import {
  MenuItem,
  Select,
  ListItemText,
  SelectChangeEvent,
} from "@mui/material";
import { useTranslate } from "@refinedev/core";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useMarketplaceStore } from "../../../store/useMarketplaceStore";

export const SelectStore = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { countries, selectCountry, selectedCountry, initialized } =
    useMarketplaceStore();

  if (!initialized) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent<string>) => {
    if (event.target.value === "add-store") return;
    selectCountry(event.target.value);
  };
  return (
    <Select
      value={selectedCountry?.countryCode}
      onChange={handleChange}
      displayEmpty
      defaultValue={selectedCountry?.countryCode}
      size="small"
      renderValue={(selected) => {
        if (!selected) {
          return <></>;
        }

        const selectedCountry = countries.find(
          (country) => country.countryCode === selected,
        );
        localStorage.setItem(
          "selectedCountry",
          JSON.stringify(selectedCountry || {}),
        );

        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={selectedCountry?.flagUrl + "?width=24"}
              alt={selectedCountry?.countryName}
              width="12px"
              style={{ marginRight: 8 }}
            />
            {translate(`countries.${selectedCountry?.countryCode}`)}
          </div>
        );
      }}
    >
      {countries.map((country) => (
        <MenuItem key={country.id} value={country.countryCode}>
          <img
            src={country.flagUrl + "?width=24"}
            alt={country.countryName}
            width="16px"
            style={{ margin: "0 4px" }}
          />
          <ListItemText
            primary={translate(`countries.${country.countryCode}`)}
          />
        </MenuItem>
      ))}

      <MenuItem onClick={() => navigate("store/create")} value="add-store">
        <AddIcon fontSize="small" sx={{ marginRight: "4px" }} />
        <ListItemText primary={translate("pages.stores.addNew")} />
      </MenuItem>
    </Select>
  );
};
